import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';

import { AppPropertiesService } from '../../../services/app-properties/app-properties.service';

/**
 * Component for the not found page.
 *
 * @author Jesse Bloomster e020902
 */
@Component({
	selector: 'claim-tracker-not-found',
	templateUrl: './not-found.component.html',
	imports: [RouterLink],
	styleUrls: ['./not-found.component.css']
})
export class NotFoundComponent implements OnInit {
	aoLostImgUrl: string;

	/**
	 * @param appPropertiesService the global app properties service
	 */
	constructor(private appPropertiesService: AppPropertiesService) {}

	/**
	 * Called when the component is initialized.
	 */
	ngOnInit() {
		this.aoLostImgUrl = this.appPropertiesService.appProperties.aoLostImgUrl ?? '';
	}
}
